import { fromEvent, merge } from 'rxjs';

/**
 * Create an observable from multiple events on the same element
 * @param {HTMLElement} element
 * @param {...string[]} events
 * @return {Observable<any>}
 */
export default function fromEvents(element, ...events) {
    const events$ = events.map(event => fromEvent(element, event));

    return merge(...events$);
}
